import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const DroppableContainer = ({ children, provided, isDragging, isDropDisabled }) => {
  const containerClass = classNames(
    `p-b-7`,
    { 'bg-green--light': isDragging && !isDropDisabled },
  );
  return (
    <div ref={provided.innerRef} {...provided.droppableProps} className={containerClass}>
      {children}
    </div>
  );
};

DroppableContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  provided: PropTypes.object,
  isDragging: PropTypes.bool,
  isDropDisabled: PropTypes.bool,
};

export default DroppableContainer;



// WEBPACK FOOTER //
// ./library/app/components/Folders/DroppableContainer.js